import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "10",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M14.227 0 5.52 8.454.797 3.871 0 4.644 5.52 10 15 .77z",
  fill: "#FF6458",
  "fill-rule": "nonzero"
}, null, -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}
export default render